import { axiosInstance } from '@/lib/utils';
import { endpoints } from '@/api';
import type { PickupLocation, RequestResponse } from '@/types';

export const fetchPickupLocations = async (): Promise<PickupLocation[]> => {
  const response = await axiosInstance<
    RequestResponse<PickupLocation[] | { data: PickupLocation[] }>
  >(endpoints.pickupLocations);
  const raw = response.data.data;
  if (Array.isArray(raw)) return raw;
  if (
    raw &&
    typeof raw === 'object' &&
    Array.isArray((raw as { data?: PickupLocation[] }).data)
  ) {
    return (raw as { data: PickupLocation[] }).data;
  }
  return [];
};

export const fetchPickupLocation = async (
  id: number
): Promise<PickupLocation> => {
  const response = await axiosInstance<RequestResponse<PickupLocation>>(
    `${endpoints.pickupLocations}/${id}`
  );
  return response.data.data as PickupLocation;
};
